(function () {
  'use strict';

  function webSocketFactory ($websocket) {
    const factory = {};

    function open (socketUrl, requestId, callback, errCallback) {
      const data = {
        action: 'registerConnection',
        requestId: requestId
      };

      if (!factory.connection) {
        factory.connection = $websocket(socketUrl);
        factory.connection.onOpen((res) => {
          factory.connection.send(JSON.stringify(data));
        });
      } else {
        factory.connection.send(JSON.stringify(data));
      }

      factory.connection.onMessage(callback);
      factory.connection.onError(errCallback);

    }

    function close () {
      if (factory.connection) {
        factory.connection.close();
      }

      factory.connection = null;
    }

    factory.open = open;
    factory.close = close;

    return factory;

  }

  angular.module('web2print.shared')
      .factory('webSocketFactory', webSocketFactory);
})();
